import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { TariffsModuleService } from '../proxy/controlling/controllers/tariffs-module.service';

FieldBuilder.setNamespace('Controlling');

export const COSTCATEGORY_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.CostCategory.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
  FieldBuilder
    .text('code', 'Entity.CostCategory.Code')
    .required()
    .minLength(1)
    .maxLength(25)
    .build(),
  FieldBuilder
    .foreignKey('tariffsModuleId', 'Entity.TariffsModule', TariffsModuleService)
    .required()
    .displayFromNested('tariffsModule.name')
    .sortBy('tariffsModule.name')
    .build(),
];

export const COSTCATEGORY_CONFIG = {
  entityName: 'CostCategory',
  localizationKey: 'Controlling::Entity.CostCategory',
  fields: COSTCATEGORY_FIELDS,
  permission: 'ControllingLiquidations.CostCategories',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Liquidations + MENU_NAME_SUFFIX,
};
